export default {
  // 银行交易流水查询
  LIST_BANK_TRADE_DETAIL_BY_PAGE: '/financial/bankTradeDetail/queryPage',
  // 银行交易流水导出
  EXPORT_BANK_TRADE_DETAIL: '/financial/bankTradeDetail/exportExcel',
  // 当日银行交易流水查询
  LIST_BANKDAY_TRADE_DETAIL_BY_PAGE: '/financial/bankTradeDetail/queryTodayPage',
};
